import MarkerComment from "@/domain/MarkerComment";
import ClientBase from "../ClientBase";
import AnomalyMarker from "@/domain/marker/AnomalyMarker";
import MarkerType from "@/domain/marker/MarkerType";

class MarkerClient extends ClientBase {

    // MARKERS //
    async createMarker(newMarker) {
        const data = await this.post('api/v1/markers', newMarker);
        return data ? new AnomalyMarker(data) : null;
    }

    async getMarkersByAssetId(assetId) {
        const data = await this.getAllPaged(`api/v1/markers/assets/${assetId}`);
        return data?.map(marker => new AnomalyMarker(marker)) ?? [];
    }

    async getMarkersByScanId(scanId) {
        const data = await this.getAllPaged(`api/v1/markers/scans/${scanId}`);
        return data?.map(marker => new AnomalyMarker(marker)) ?? [];
    }

    async getById(scanId, markerId) {
        const data = await this.get(`api/v1/markers/scans/${scanId}/markers/${markerId}`);
        return data ? new AnomalyMarker(data) : null;
    }

    async updateMarker(marker) {
        const data = await this.put(`api/v1/markers/${marker.scanId}/${marker.id}`, marker, { headers: { 'If-Match': marker.eTag } });
        return data ? new AnomalyMarker(data) : null;
    }

    async updateMarkerThumbnail(request) {
        const data = await this.put(`api/v1/markers/scans/${request.scanId}/markers/${request.id}/thumbnail`, request);
        return data ? new AnomalyMarker(data) : null;
    }

    async updateMarkerDetails(scanId, markerId, details) {
        const data = await this.put(`api/v1/markers/scans/${scanId}/markers/${markerId}/details`, details);
        return data ? new AnomalyMarker(data) : null;
    }

    async assignMarkerTags(scanId, markerId, tagIds) {
        const data = await this.put(`api/v1/markers/scans/${scanId}/markers/${markerId}/tags`, { tagIds });
        return data ? new AnomalyMarker(data) : null;
    }

    async updateMarkerStatus(marker) {
        let status = "";
        switch (marker.status) {
            case "Approved": status = "marker-approved"; break;
            case "Rejected": status = "marker-rejected"; break;
        }

        if (!status) return null;

        const data = await this.put(`api/v1/markers/scans/${marker.scanId}/markers/${marker.id}/status/${status}`, {});
        return data ? new AnomalyMarker(data) : null;
    }

    async deleteMarker(marker) {
        return await this.delete(`api/v1/markers/scans/${marker.scanId}/markers/${marker.id}`);
    }



    // COMMENTS // (comments remain partitioned by assetId)
    async createMarkerComment(newComment) {
        const data = await this.post('api/v1/markercomments', newComment);
        return data ? new MarkerComment(data) : null;
    }

    async getCommentsByMarkerId(markerId) {
        const data = await this.get(`api/v1/markercomments/markers/${markerId}`);
        return data?.map(comment => new MarkerComment(comment)) ?? [];
    }



    // CATEGORIES //
    async createMarkerType(newCategory) {
        const data = await this.post('api/v1/markertypes', newCategory);
        return data ? new MarkerType(data) : null;
    }

    async getMarkerTypesByOrganizationId(organizationId) {
        const data = await this.get(`api/v1/markertypes/${organizationId}`);
        return data?.map(category => new MarkerType(category)) ?? [];
    }

    async updateMarkerType(category) {
        const data = await this.put(`api/v1/markertypes/${category.organizationId}/${category.id}`, category);
        return data ? new MarkerType(data) : null;
    }



    // EVENTS //
    async getEventsByMarkerId(markerId) {
        return await this.get(`api/v1/markerevent/${markerId}`);
    }
}

export default new MarkerClient();
